__turbopack_context__.v({
  "active": "Ybs5iq_active",
  "dot": "Ybs5iq_dot",
  "dotContainer": "Ybs5iq_dotContainer",
  "inArticleNav": "Ybs5iq_inArticleNav",
  "line": "Ybs5iq_line",
  "lineContainer": "Ybs5iq_lineContainer",
  "linksContainer": "Ybs5iq_linksContainer",
  "nav": "Ybs5iq_nav",
  "navItem": "Ybs5iq_navItem",
  "navItems": "Ybs5iq_navItems",
  "navLabel": "Ybs5iq_navLabel",
  "navTitle": "Ybs5iq_navTitle",
  "nested": "Ybs5iq_nested",
});
